/* eslint-disable @angular-eslint/component-selector */
import { DatePipe } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { GridDataResult } from '@progress/kendo-angular-grid';
import { moreVerticalIcon } from '@progress/kendo-svg-icons';
import { BehaviorSubject } from 'rxjs';
import { StudentService } from 'src/app/services/student.service';
import { ColumnType } from 'src/app/shared/enums/column-type';
import { ColumnComponentInputs } from 'src/app/shared/interfaces/column-component-inputs';
import { EventLog } from 'src/app/shared/interfaces/event-log';
import { StudentDetails } from '../../interfaces/student-details';
import { AbstractComponent } from '../abstract-component';

 
@Component({
  // TODO: Not sure if we need to change the selector name to app-events-log
  selector: 'events-log',
  templateUrl: './events-log.component.html',
  styleUrls: ['./events-log.component.scss'],
  providers: [DatePipe],
  standalone: false
})
export class EventsLogComponent
  extends AbstractComponent
  implements OnChanges, OnInit {
  @Input() studentSk: string;
  @Output() refreshGrid: EventEmitter<void> = new EventEmitter<void>();
  @Input() stdentDetails: StudentDetails;
  @Input() nycId: string;
  @Input() isEI?: boolean = false;
  loadSpinner: boolean;
  gridTitle: string = '';
  @Input() gridHeader: string = '';
  gridApiRoute: string = 'EventLog';
  showAddEventLogModal$: BehaviorSubject<boolean> =
    new BehaviorSubject<boolean>(false);
  showStudentRelatedEventsDialog$: BehaviorSubject<boolean> =
    new BehaviorSubject<boolean>(false);
  dataLoaded: boolean;
  gridData: GridDataResult = {
    data: [],
    total: 0,
  };
  // TODO: Not sure of the datatype. Define and use a proper datatype instead of any
  initialGridState: any = {
    skip: 0,
    take: 10,
    sort: [],
    group: [],
    filter: {
      field: 'eventType',
      operator: 'eq',
      value: 'Manual',
      logic: 'or',
      filters: [],
    },
  };
  refershGrid: boolean;
  module: string = 'Event Logs';
  studentEventLogData: EventLog[];
  columnDefinitions: ColumnComponentInputs[]
  addButtonText: string = 'Log Event';

  constructor(public studentService: StudentService) {
    super();
  }

  ngOnInit(): void {
    if (!this.studentSk) {
      this.loadSpinner = true;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.studentSk && this.studentSk) {
      this.dataLoaded = true;
      this.loadSpinner = false;
      if (this.gridHeader === 'Historical Events Log') {
        this.columnDefinitions = [
          {
            title: 'Type',
            field: 'eventType',
            columnType: ColumnType.select,
          },
          {
            title: 'Date/Time Occurred',
            field: 'dateTimeOccurred',
            columnType: ColumnType.dateTime,
            width: 150,
          },
          {
            title: 'Event Subject',
            field: 'eventSubject',
            columnType: ColumnType.text,
            width: 400,
          },
          {
            title: 'Logged By',
            field: 'loggedBy',
            columnType: ColumnType.text,
            filterable: false,
          },
          {
            title: 'Generated',
            field: 'generated',
            columnType: ColumnType.select,
            filterable: false,
          },
        ];
      } else {
        this.columnDefinitions = [
          {
            title: '',
            field: '',
            icon: moreVerticalIcon,
            columnType: ColumnType.icon,
          },
          {
            title: 'Type',
            field: 'eventType',
            columnType: ColumnType.select,
          },
          {
            title: 'Date/Time Occurred',
            field: 'dateTimeOccurred',
            columnType: ColumnType.dateTime,
            width: 150,
          },
          {
            title: 'Event Subject',
            field: 'eventSubject',
            columnType: ColumnType.text,
            width: 400,
          },
          {
            title: 'Logged By',
            field: 'loggedBy',
            columnType: ColumnType.text,
            filterable: false,
          },
          {
            title: 'Generated',
            field: 'generated',
            columnType: ColumnType.select,
            filterable: false,
          },
        ];
      }
    }
  }

  getStudentDetails(): void {
    this.studentService.studentDetailsById(this.nycId).subscribe({
      next: (response: StudentDetails) => {
        this.stdentDetails = response;
      },
    });
  }

  openStudentRelatedEventsDialog(): void {
    this.showStudentRelatedEventsDialog$.next(true);
  }

  closeStudentRelatedEventsDialog(): void {
    this.showStudentRelatedEventsDialog$.next(false);
    this.studentService.refreshGridData(true);
  }

  openAddEventModalHandler(): void {
    this.openStudentRelatedEventsDialog();
  }

  override afterOnDestroy(): void {
    // afterOnDestroy
  }
}
